/* Studio Spice · commerce layer (sb-product, sb-cart-drawer, sb-cart-page)
   Own code, no theme dependencies. Uses the Shopify Ajax Cart API + Section Rendering API.
   Config comes from snippets/sb-commerce-head.liquid (window.SBShop). */
(function () {
  'use strict';

  var shop = window.SBShop || {};
  var routes = shop.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update' };
  var DRAWER_ID = 'sb-cart-drawer';
  var BUBBLE_ID = 'sb-cart-bubble';

  /* ───────── helpers ───────── */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);
    var fmt = shop.moneyFormat || '€{{amount_with_comma_separator}}';
    if (shop.currency && shop.shopCurrency && shop.currency !== shop.shopCurrency) {
      try {
        return new Intl.NumberFormat(shop.locale || document.documentElement.lang || 'en', { style: 'currency', currency: shop.currency }).format(cents / 100);
      } catch (e) { /* fall through to shop format */ }
    }
    function fmtNum(n, dec, thou, decSep) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return s.join(decSep);
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount_no_decimals': val = fmtNum(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': val = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = fmtNum(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = fmtNum(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': val = fmtNum(cents, 2, ' ', ','); break;
      default: val = fmtNum(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }

  function rate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || data.status) {
          var msg = data.description || data.message || shop.cartError || 'Something went wrong. Please try again.';
          var err = new Error(typeof msg === 'string' ? msg : shop.cartError);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function parseHTML(html) { return new DOMParser().parseFromString(html || '', 'text/html'); }

  /* text with [token] replaced by a <strong> node (keeps everything else as plain text) */
  function fillToken(el, text, token, value) {
    el.textContent = '';
    var parts = String(text).split(token);
    parts.forEach(function (p, i) {
      if (p) el.appendChild(document.createTextNode(p));
      if (i < parts.length - 1) {
        var b = document.createElement('strong');
        b.textContent = value;
        el.appendChild(b);
      }
    });
  }

  /* ───────── delivery estimate ───────── */
  function fillDelivery(root) {
    $$('[data-sb-delivery]', root).forEach(function (el) {
      var days = parseInt(el.getAttribute('data-days'), 10) || 3;
      var skip = el.getAttribute('data-skip-weekends') !== 'false';
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
      var d = new Date();
      if (!isNaN(cutoff) && cutoff < 24 && d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (!skip || (wd !== 0 && wd !== 6)) added++;
      }
      var label;
      try {
        label = new Intl.DateTimeFormat(shop.locale || document.documentElement.lang || 'en', { weekday: 'long', month: 'long', day: 'numeric' }).format(d);
      } catch (e) { label = d.toDateString(); }
      var target = $('[data-sb-delivery-text]', el) || el;
      fillToken(target, el.getAttribute('data-text') || '[date]', '[date]', label);
    });
  }

  /* ───────── goal bar ───────── */
  function fillGoals(root) {
    $$('[data-sb-goals]', root).forEach(function (bar) {
      var byQty = bar.getAttribute('data-basis') === 'quantity';
      var value = byQty ? parseInt(bar.getAttribute('data-qty'), 10) || 0 : parseInt(bar.getAttribute('data-total'), 10) || 0;
      var stops = $$('[data-sb-goal]', bar).map(function (el) {
        var a = parseFloat(el.getAttribute('data-amount')) || 0;
        return { el: el, need: byQty ? a : Math.round(a * 100 * rate()), reward: el.getAttribute('data-reward') };
      }).sort(function (a, b) { return a.need - b.need; });
      if (!stops.length) return;
      var max = stops[stops.length - 1].need || 1;
      var fill = $('[data-sb-goals-fill]', bar);
      if (fill) fill.style.width = Math.min(100, (value / max) * 100) + '%';
      var next = null;
      stops.forEach(function (s) {
        s.el.style.left = Math.min(100, (s.need / max) * 100) + '%';
        var hit = value >= s.need;
        s.el.classList.toggle('is-hit', hit);
        if (!hit && !next) next = s;
      });
      var msg = $('[data-sb-goals-msg]', bar);
      if (!msg) return;
      if (!next) {
        msg.textContent = bar.getAttribute('data-done') || '';
      } else {
        var missing = next.need - value;
        var amount = byQty ? String(missing) : formatMoney(missing);
        var tpl = (bar.getAttribute('data-msg') || '[amount] → [next_goal]').replace('[next_goal]', next.reward || '');
        fillToken(msg, tpl, '[amount]', amount);
      }
    });
  }

  /* ───────── cart (drawer + page) ───────── */
  var Cart = {
    drawer: null,
    busy: false,
    lastFocus: null,

    sectionIds: function () {
      var ids = [BUBBLE_ID];
      if ($('#SbCart')) ids.push(DRAWER_ID);
      $$('[data-sb-cartpage]').forEach(function (p) { ids.push(p.getAttribute('data-section-id')); });
      return ids;
    },

    apply: function (sections) {
      if (!sections) return;
      if (sections[DRAWER_ID]) {
        var inner = $('[data-sb-cart-inner]', parseHTML(sections[DRAWER_ID]));
        var cur = $('#SbCart [data-sb-cart-inner]');
        if (inner && cur) cur.innerHTML = inner.innerHTML;
      }
      if (sections[BUBBLE_ID]) {
        var wrap = parseHTML(sections[BUBBLE_ID]).body.firstElementChild;
        if (wrap) $$('#cart-icon-bubble').forEach(function (b) { b.innerHTML = wrap.innerHTML; });
      }
      $$('[data-sb-cartpage]').forEach(function (p) {
        var html = sections[p.getAttribute('data-section-id')];
        if (!html) return;
        var inn = $('[data-sb-cartpage-inner]', parseHTML(html));
        var cur2 = $('[data-sb-cartpage-inner]', p);
        if (inn && cur2) cur2.innerHTML = inn.innerHTML;
      });
      Cart.after();
    },

    /* free gift: add the gift line once the goal is reached, remove it again below the goal */
    giftBusy: false,
    syncGift: function () {
      var el = $('#SbCart [data-sb-gift]');
      if (!el || Cart.busy || Cart.giftBusy) return;
      var need = Math.round((parseFloat(el.getAttribute('data-amount')) || 0) * 100 * rate());
      var base = parseInt(el.getAttribute('data-base'), 10) || 0;
      var line = parseInt(el.getAttribute('data-line'), 10) || 0;
      var owned = el.getAttribute('data-owned') === 'true';
      var vid = Number(el.getAttribute('data-variant'));
      if (!need || !vid) return;
      var done = function () { Cart.giftBusy = false; };
      if (base >= need && !line && !owned) {
        Cart.giftBusy = true;
        Cart.add([{ id: vid, quantity: 1, properties: { _sb_gift: '1' } }], { silent: true }).then(done, done);
      } else if (line && (base < need || owned)) {
        Cart.giftBusy = true;
        Cart.change(line, 0).then(done, done);
      }
    },

    after: function () {
      setTimeout(Cart.syncGift, 0);
      fillDelivery(document.getElementById('SbCart'));
      fillGoals(document.getElementById('SbCart'));
      $$('[data-sb-cartpage]').forEach(function (p) { fillDelivery(p); fillGoals(p); });
    },

    refresh: function () {
      var url = routes.root + (routes.root.slice(-1) === '/' ? '' : '/') + '?sections=' + Cart.sectionIds().join(',');
      return fetch(url).then(function (r) { return r.json(); }).then(Cart.apply).catch(function () {});
    },

    setBusy: function (on) {
      Cart.busy = on;
      $$('#SbCart, [data-sb-cartpage]').forEach(function (el) { el.classList.toggle('is-busy', on); });
    },

    error: function (msg) {
      var host = $('#SbCart .sb-cart__body') || $('[data-sb-cartpage-inner]');
      if (!host) { window.alert(msg); return; }
      var p = $('[data-sb-cart-err]', host);
      if (!p) {
        p = document.createElement('p');
        p.className = 'sb-pdp__error';
        p.setAttribute('role', 'alert');
        p.setAttribute('data-sb-cart-err', '');
        host.insertBefore(p, host.firstChild);
      }
      p.textContent = msg;
    },

    change: function (line, quantity, extra) {
      if (Cart.busy) return Promise.resolve();
      Cart.setBusy(true);
      var body = { line: Number(line), quantity: Math.max(0, Number(quantity) || 0), sections: Cart.sectionIds(), sections_url: window.location.pathname };
      if (extra) Object.keys(extra).forEach(function (k) { body[k] = extra[k]; });
      return postJSON(routes.cartChange + '.js', body)
        .then(function (data) { Cart.setBusy(false); Cart.apply(data.sections); })
        .catch(function (e) { Cart.setBusy(false); Cart.refresh().then(function () { Cart.error(e.message); }); });
    },

    add: function (items, opts) {
      var silent = opts && opts.silent;
      var body = { items: items, sections: Cart.sectionIds(), sections_url: window.location.pathname };
      return postJSON(routes.cartAdd + '.js', body).then(function (data) {
        if (!$('#SbCart')) { if (!silent) window.location.href = routes.cart; return data; }
        if (data.sections) Cart.apply(data.sections); else Cart.refresh();
        if (silent) return data;
        Cart.open();
        document.dispatchEvent(new CustomEvent('sb:cart:added', { detail: data }));
        return data;
      });
    },

    open: function () {
      var d = $('#SbCart');
      if (!d) { window.location.href = routes.cart; return; }
      Cart.lastFocus = document.activeElement;
      d.setAttribute('aria-hidden', 'false');
      d.classList.add('is-open');
      document.documentElement.classList.add('sb-cart-open');
      Cart.after();
      var panel = $('.sb-cart__panel', d);
      if (panel) setTimeout(function () { panel.focus(); }, 30);
    },

    close: function () {
      var d = $('#SbCart');
      if (!d) return;
      d.setAttribute('aria-hidden', 'true');
      d.classList.remove('is-open');
      document.documentElement.classList.remove('sb-cart-open');
      if (Cart.lastFocus && Cart.lastFocus.focus) Cart.lastFocus.focus();
    }
  };

  var noteTimer;
  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('#cart-icon-bubble, [data-sb-cart-open]');
    if (opener && $('#SbCart') && !document.body.classList.contains('template-cart') && !$('[data-sb-cartpage]')) {
      e.preventDefault();
      Cart.open();
      return;
    }
    if (t.closest('[data-sb-cart-close]')) { e.preventDefault(); Cart.close(); return; }

    var step = t.closest('[data-sb-line-qty]');
    if (step) {
      var input = step.parentNode.querySelector('[data-sb-line-input]');
      var q = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-sb-line-qty'), 10);
      input.value = Math.max(0, q);
      Cart.change(step.getAttribute('data-line'), input.value);
      return;
    }
    var rm = t.closest('[data-sb-line-remove]');
    if (rm) { e.preventDefault(); Cart.change(rm.getAttribute('data-line'), 0); return; }

    var addBtn = t.closest('[data-sb-cart-add]');
    if (addBtn) {
      e.preventDefault();
      addBtn.disabled = true;
      Cart.add([{ id: Number(addBtn.getAttribute('data-sb-cart-add')), quantity: 1 }])
        .catch(function (err) { Cart.error(err.message); })
        .then(function () { addBtn.disabled = false; });
      return;
    }

    var apply = t.closest('[data-sb-discount-apply]');
    if (apply) {
      var box = apply.closest('.sb-cartpage__code');
      var field = $('[data-sb-discount-input]', box);
      var code = (field.value || '').trim();
      var err = $('[data-sb-discount-error]', box);
      if (!code) { if (err) err.hidden = false; field.focus(); return; }
      window.location.href = routes.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routes.cart);
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-sb-line-input]')) { Cart.change(t.getAttribute('data-line'), t.value); return; }
    if (t.matches('[data-sb-line-plan]')) {
      /* switch on = add the plan; switch off = back to one-time purchase (selling_plan null) */
      var planId = t.getAttribute('data-sb-line-plan');
      var plan = t.checked && planId ? Number(planId) : null;
      Cart.change(t.getAttribute('data-line'), t.getAttribute('data-qty'), { selling_plan: plan });
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-sb-cart-note]')) return;
    var v = e.target.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { postJSON(routes.cartUpdate + '.js', { note: v }).catch(function () {}); }, 500);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && $('#SbCart.is-open')) Cart.close();
    if (e.key === 'Enter' && e.target.matches('[data-sb-discount-input]')) {
      e.preventDefault();
      var btn = $('[data-sb-discount-apply]', e.target.closest('.sb-cartpage__code'));
      if (btn) btn.click();
    }
  });

  /* other scripts (e.g. the AI product-overview block) can ask for a refresh */
  document.addEventListener('cart:refresh', function () { Cart.refresh().then(Cart.open); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });

  /* ───────── product ───────── */
  function Product(root) {
    this.root = root;
    var json = $('[data-sb-product-json]', root);
    this.data = json ? JSON.parse(json.textContent) : { variants: [] };
    this.form = document.getElementById(root.getAttribute('data-form-id'));
    this.variant = null;
    var idInput = this.form && $('[data-sb-variant-id]', this.form);
    var curId = idInput ? Number(idInput.value) : null;
    this.variant = this.data.variants.filter(function (v) { return v.id === curId; })[0] || this.data.variants[0];
    this.bind();
    this.syncPurchase();
    this.markOptions();
    this.updateTotals();
    this.gallery();
    this.stickyBar();
    fillDelivery(root);
  }

  Product.prototype.selectedOptions = function () {
    var root = this.root, out = [];
    $$('[data-sb-option]', root).forEach(function (el) {
      var i = Number(el.getAttribute('data-sb-option'));
      if (el.type === 'radio') { if (el.checked) out[i] = el.value; }
      else out[i] = el.value;
    });
    return out;
  };

  Product.prototype.findVariant = function (opts) {
    return this.data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
    })[0] || null;
  };

  Product.prototype.markOptions = function () {
    var self = this, sel = this.selectedOptions();
    $$('[data-sb-option]', this.root).forEach(function (el) {
      var i = Number(el.getAttribute('data-sb-option'));
      var options = el.tagName === 'SELECT' ? $$('option', el) : [el];
      options.forEach(function (opt) {
        var test = sel.slice(); test[i] = opt.value;
        var ok = self.data.variants.some(function (v) {
          return v.available && v.options.every(function (o, k) { return test[k] === undefined || test[k] === o; });
        });
        var target = el.tagName === 'SELECT' ? opt : el.closest('.sb-pdp__vpill');
        if (target) target.classList.toggle('is-soldout', !ok);
      });
    });
    $$('[data-sb-optvalue]', this.root).forEach(function (s) { s.textContent = sel[Number(s.getAttribute('data-sb-optvalue'))] || ''; });
  };

  Product.prototype.plan = function () {
    var sub = $('[data-sb-purchase][value="subscription"]', this.root);
    if (!sub || !sub.checked) return null;
    var pick = $('[data-sb-plan]', this.root);
    return pick ? pick.value : null;
  };

  Product.prototype.priceFor = function () {
    var v = this.variant;
    if (!v) return null;
    var p = this.plan();
    if (p && v.plans && v.plans[p]) return { cents: v.plans[p].price, text: v.plans[p].priceText, compare: v.plans[p].compareText, save: v.plans[p].save };
    return { cents: v.price, text: v.priceText, compare: v.compareText, save: v.save };
  };

  Product.prototype.qty = function () {
    var q = $('[data-sb-qty-input]', this.root);
    return q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
  };

  Product.prototype.syncPurchase = function () {
    var root = this.root;
    var planInput = this.form && $('[data-sb-plan-input]', this.form);
    var p = this.plan();
    if (planInput) { planInput.value = p || ''; planInput.disabled = !p; }
    $$('[data-sb-purchase]', root).forEach(function (r) {
      var lab = r.closest('.sb-pdp__subopt');
      if (lab) lab.classList.toggle('is-on', r.checked);
    });
    var v = this.variant;
    if (v) {
      var ot = $('[data-sb-onetime-price]', root);
      if (ot) ot.textContent = v.priceText;
      var sp = $('[data-sb-sub-price]', root);
      var pick = $('[data-sb-plan]', root);
      var a = pick && v.plans ? v.plans[pick.value] : null;
      if (sp && a) {
        sp.textContent = a.priceText;
        if (a.compareText) { var s = document.createElement('s'); s.textContent = a.compareText; sp.appendChild(s); }
      }
    }
  };

  Product.prototype.renderPrice = function () {
    var pr = this.priceFor(), root = this.root;
    var box = $('[data-sb-price]', root);
    if (box && pr) {
      var now = $('[data-sb-now]', box), was = $('[data-sb-was]', box), save = $('[data-sb-save]', box), unit = $('[data-sb-unit]', box);
      if (now) now.textContent = pr.text;
      if (was) { was.textContent = pr.compare || ''; was.hidden = !pr.compare; }
      if (save) { save.textContent = (save.getAttribute('data-label') || 'Save') + ' ' + pr.save + '%'; save.hidden = !pr.save; }
      if (unit) { unit.textContent = this.variant.unitText || ''; unit.hidden = !this.variant.unitText; }
    }
  };

  Product.prototype.updateTotals = function () {
    var root = this.root, v = this.variant, pr = this.priceFor();
    var available = !!(v && v.available);
    var total = pr ? pr.cents * this.qty() : 0;
    $$('[data-sb-up-check]', root).forEach(function (c) { if (c.checked) total += Number(c.getAttribute('data-price')) || 0; });
    var btn = $('[data-sb-atc]', root);
    if (btn) {
      btn.disabled = !available;
      var lab = $('[data-sb-atc-label]', btn);
      if (lab) lab.textContent = available ? btn.getAttribute('data-label') : (v ? this.data.soldOut : this.data.unavailable);
      var bp = $('[data-sb-atc-price]', btn);
      if (bp) { bp.textContent = formatMoney(total); bp.hidden = !available; }
    }
    var barBtn = $('[data-sb-bar-btn]', root);
    if (barBtn) { barBtn.disabled = !available; barBtn.textContent = available ? (shop.addToCart || 'Add to cart') : (v ? this.data.soldOut : this.data.unavailable); }
    var barPrice = $('[data-sb-bar-price]', root);
    if (barPrice) barPrice.textContent = available ? formatMoney(total) : '';
    this.renderPrice();
  };

  Product.prototype.onVariant = function () {
    var opts = this.selectedOptions();
    this.variant = this.findVariant(opts);
    this.markOptions();
    if (this.variant) {
      var idInput = this.form && $('[data-sb-variant-id]', this.form);
      if (idInput) idInput.value = this.variant.id;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', this.variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
      if (this.variant.media) this.goToMedia(this.variant.media);
    }
    this.syncPurchase();
    this.updateTotals();
  };

  Product.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-sb-option]')) self.onVariant();
      else if (t.matches('[data-sb-purchase], [data-sb-plan]')) { self.syncPurchase(); self.updateTotals(); }
      else if (t.matches('[data-sb-up-variant]')) {
        var o = t.options[t.selectedIndex], li = t.closest('[data-sb-up]');
        var c = $('[data-sb-up-check]', li);
        c.value = t.value; c.setAttribute('data-price', o.getAttribute('data-price'));
        var pt = $('[data-sb-up-price]', li); if (pt) pt.textContent = o.getAttribute('data-price-text');
        self.updateTotals();
      } else if (t.matches('[data-sb-up-check], [data-sb-qty-input]')) self.updateTotals();
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sb-qty]');
      if (!b) return;
      var input = $('[data-sb-qty-input]', root);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-sb-qty')));
      self.updateTotals();
    });
    if (this.form) this.form.addEventListener('submit', function (e) { self.submit(e); });
  };

  Product.prototype.submit = function (e) {
    if (!this.variant || !this.variant.available) { e.preventDefault(); return; }
    var submitter = e.submitter;
    if (submitter && submitter.closest('.shopify-payment-button')) return; /* express checkout */
    e.preventDefault();
    var root = this.root, btn = $('[data-sb-atc]', root), err = $('[data-sb-error]', root);
    if (err) { err.hidden = true; err.textContent = ''; }
    var main = { id: this.variant.id, quantity: this.qty() };
    var p = this.plan();
    if (p) main.selling_plan = Number(p);
    var items = [main];
    $$('[data-sb-up-check]', root).forEach(function (c) { if (c.checked) items.push({ id: Number(c.value), quantity: 1 }); });
    if (btn) btn.classList.add('is-loading');
    root.classList.add('is-busy');
    Cart.add(items)
      .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
      .then(function () { if (btn) btn.classList.remove('is-loading'); root.classList.remove('is-busy'); });
  };

  Product.prototype.goToMedia = function (mediaId) {
    var slide = $('.sb-pdp__slide[data-media-id="' + mediaId + '"]', this.root);
    if (slide) this.goTo(Number(slide.getAttribute('data-index')));
  };

  Product.prototype.goTo = function (i) {
    var track = $('[data-sb-track]', this.root);
    var slides = track ? $$('.sb-pdp__slide', track) : [];
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    this.setActive(i);
  };

  Product.prototype.setActive = function (i) {
    this.active = i;
    $$('.sb-pdp__slide', this.root).forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    $$('[data-sb-thumb]', this.root).forEach(function (t, k) {
      t.classList.toggle('is-active', k === i);
      if (k === i) {
        t.setAttribute('aria-current', 'true');
        var list = t.closest('[data-sb-thumbs]');
        if (list) list.scrollTo({ left: t.parentNode.offsetLeft - list.offsetLeft - 8, behavior: 'smooth' });
      } else t.removeAttribute('aria-current');
    });
  };

  Product.prototype.gallery = function () {
    var self = this, root = this.root, track = $('[data-sb-track]', root);
    if (!track) return;
    var start = $('.sb-pdp__slide.is-active', track);
    if (start && start.offsetLeft) track.scrollLeft = start.offsetLeft - track.offsetLeft;
    this.active = start ? Number(start.getAttribute('data-index')) || 0 : 0;
    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-sb-thumb]');
      if (th) { self.goTo(Number(th.getAttribute('data-sb-thumb'))); return; }
      if (e.target.closest('[data-sb-prev]')) self.goTo(self.active - 1);
      if (e.target.closest('[data-sb-next]')) self.goTo(self.active + 1);
    });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== self.active) self.setActive(i);
      }, 80);
    }, { passive: true });
  };

  Product.prototype.stickyBar = function () {
    var bar = $('[data-sb-bar]', this.root), btn = $('[data-sb-atc]', this.root);
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', show);
    }).observe(btn);
  };

  /* ───────── boot ───────── */
  function init(scope) {
    $$('[data-sb-pdp]', scope).forEach(function (el) {
      if (el.__sb) return;
      el.__sb = new Product(el);
    });
    Cart.after();
    fillDelivery(scope);
  }

  window.SBCart = Cart;
  window.SBMoney = formatMoney;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
